import React from "react"

import ReactDOM from "react-dom"

import "semantic-ui-less/semantic.less"

import dayjs from "dayjs"
import "dayjs/locale/pt-br"
import localizedFormat from "dayjs/plugin/localizedFormat"

import App from "./App"

import { GlobalStyles } from "./global-styles/GlobalStyles"
import "./global-styles/styles.scss"
import { StoreProvider } from "./stores/useStoreProfile"

dayjs.locale("pt-br")
dayjs.extend(localizedFormat)

ReactDOM.render(
  <>
    <GlobalStyles />
    <StoreProvider>
      <App />
    </StoreProvider>
  </>,
  document.getElementById("root")
)
